<script setup>
import OperationsAjustementTab from '@/components/fiche-aim/fiche-aim/ajustement/operation/OperationsAjustementTab.vue'
</script>

<template>
  <v-form @submit.prevent.stop="envoyerAjoutAjustement">
    <v-textarea
      class="textarea"
      outlined
      color="secondary"
      label="Justification"
      no-resize
      rows="2"
      required
      v-model="justification"
      :rules="[(v) => !!v || 'Vous devez renseigner une justification']"
    />

    <operations-ajustement-tab
      :loading="loading"
      :operations="operations"
      :postesDisponibles="postesDisponibles"
      @add="ajouterOperation"
      @update="modifierOperationAjustement"
      @del="(posteAIMId) => supprimerOperation(posteAIMId)"
    />
    <v-card-actions>
      <v-spacer />
      <v-btn @click="clear">Vider</v-btn>
      <v-btn @click="$emit('close')">Fermer</v-btn>
      <v-btn type="submit" :disabled="!isValid" color="success">
        <v-fab-transition>
          <v-icon v-if="isValid">mdi-plus</v-icon>
        </v-fab-transition>
        Créer
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AjustementCreationForm',
  emits: ['created', 'close'],
  data() {
    return {
      valid: false,
      loading: true,
      justification: undefined,
      operations: [],
    }
  },
  props: {
    ficheAimId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      postesDisponibles: 'posteAIM/getPostes',
    }),
    isValid() {
      return this.justification !== undefined && this.operations.length > 0
    },
    command() {
      return {
        ficheAIMId: this.ficheAimId,
        explication: this.justification,
        operations: this.operations.map((op) => {
          return {
            montant: Number(op.montant),
            posteAIMId: op.posteAIM.posteAIMId,
          }
        }),
      }
    },
  },
  methods: {
    ...mapActions({
      fetchPostes: 'posteAIM/fetchPostes',
      ajuster: 'ficheAIM/ajusterFicheAIM',
    }),
    clear() {
      this.operations = []
      this.justification = undefined
    },
    envoyerAjoutAjustement() {
      this.ajuster(this.command).then((ajustement) => {
        this.clear()
        this.$emit('created', ajustement)
      })
    },

    ajouterOperation(operation) {
      this.operations.push(operation)
    },
    modifierOperationAjustement(op) {
      this.supprimerOperation(op.posteAIM.posteAIMId)
      this.ajouterOperation(op)
    },
    supprimerOperation(posteAIMId) {
      this.operations.splice(
        this.operations.findIndex((value) => value.posteAIM.posteAIMId === posteAIMId),
        1
      )
    },
  },
  mounted() {
    this.fetchPostes().then(() => (this.loading = false))
  },
}
</script>

<style>
textarea {
  height: 100px !important;
}

.context-box {
  height: 16vh !important;
}

.operations-box {
  height: 32vh !important;
}
</style>
